// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__1xV6-","description":"PatientConsentPreview_description__3UjE2"};